import BaseModel from "./BaseModel";
import { PaymentStage } from "./CostSpecificationRow";

class TspReceipt extends BaseModel {
  id: number;
  bookingsExternalId: number;
  paymentStage: PaymentStage;
  parameters: string;
  template: string;
  html?: string;
  emailSubject: string;

  static __dates = [];

  constructor(data) {
    super(data, TspReceipt.__dates);
    this.id = data.id;
    this.bookingsExternalId = data.bookingsExternalId;
    this.paymentStage = data.paymentStage;
    this.parameters = data.parameters;
    this.template = data.template;
    this.html = data.html;
    this.emailSubject = data.emailSubject;
  }
}

export default TspReceipt;

